import * as React from 'react'

function IconCompleteLesson(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={65}
      height={65}
      viewBox="0 0 65 65"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M32.395 63.789c17.338 0 31.394-14.056 31.394-31.395C63.789 15.056 49.733 1 32.394 1 15.056 1 1 15.056 1 32.395c0 17.338 14.056 31.394 31.395 31.394z"
        fill="#fff"
      />
      <path
        d="M32.395 63.789c17.338 0 31.394-14.056 31.394-31.395C63.789 15.056 49.733 1 32.394 1 15.056 1 1 15.056 1 32.395c0 17.338 14.056 31.394 31.395 31.394z"
        stroke="#F4BA27"
        strokeWidth={2}
        strokeMiterlimit={10}
      />
      <path
        d="M32.394 59.388c14.909 0 26.995-12.085 26.995-26.994C59.389 17.486 47.303 5.4 32.394 5.4 17.486 5.4 5.4 17.486 5.4 32.394c0 14.909 12.086 26.994 26.994 26.994z"
        stroke="#F4BA27"
        strokeWidth={0.75}
        strokeMiterlimit={10}
      />
      <path
        d="M44 26L30.005 40 23 33"
        stroke="#219321"
        strokeWidth={5}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default IconCompleteLesson
